import React from 'react';
import { Button, List } from '@spothero/ui';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import UserUtils from 'utils/user-utils';
import { dropdownElementStyling } from './styles';
const NotLoggedIn = () => {
    const location = useLocation();
    const currentURL = `${location.pathname}${location.search}`;
    return (<>
            <li>
                <Button display="block" width="100%" borderRadius="8px" marginBottom="2" asAnchor href={`/auth/restricted-login?next=${encodeURIComponent(currentURL)}`} data-testid={`login-status-sign-up`} // This used to be a combined button called login-status-link
    >
                    Sign up
                </Button>
            </li>
            <li>
                <Button variant="secondary" display="block" border="none" width="100%" borderRadius="8px" asAnchor href={`/auth/restricted-login?next=${encodeURIComponent(currentURL)}`} data-testid={`login-status-login`}>
                    Login
                </Button>
            </li>
        </>);
};
const LoggedIn = () => {
    const isAdmin = useSelector((state) => state.user.data.isAdmin);
    const isSeller = useSelector((state) => state.user.data.isSeller);
    return (<>
            <li>
                <Button {...dropdownElementStyling} href="/account-settings" data-testid="login-status-link-logged-in">
                    My Account
                </Button>
            </li>
            {isAdmin && (<li>
                    <Button {...dropdownElementStyling} color="text.link.light" href="/admin" data-testid={`header-menu-mobile-admin`}>
                        Admin
                    </Button>
                </li>)}
            {isSeller && (<li>
                    <Button {...dropdownElementStyling} color="text.link.light" href="/control-panel" data-testid={`header-menu-mobile-control-panel`} asAnchor>
                        Control Panel
                    </Button>
                </li>)}
        </>);
};
export const LoginState = () => {
    const status = useSelector((state) => state.user.data.status);
    const isLoggedIn = status === UserUtils.AUTH_STATE.USER;
    // const isLoggedIn = true;
    return (<List variant="unstyled">
            {isLoggedIn ? <LoggedIn /> : <NotLoggedIn />}
        </List>);
};
